import { alpha, type Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Button(theme: Theme) {
	return {
		MuiButton: {
			styleOverrides: {
				root: {
					'&:hover': {
						boxShadow: 'none',
					},
				},
				sizeLarge: {
					height: 48,
				},
				containedInherit: {
					color: theme.palette.grey[800],
					boxShadow: theme.customShadows.z8, // Ensure customShadows exists in theme (extend if necessary)
					'&:hover': {
						backgroundColor: theme.palette.grey[400],
					},
				},
				containedPrimary: {
					boxShadow: theme.customShadows.primary, // Ensure customShadows exists in theme
				},
				containedSecondary: {
					boxShadow: theme.customShadows.secondary, // Ensure customShadows exists in theme
				},
				outlinedInherit: {
					border: `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
					'&:hover': {
						backgroundColor: theme.palette.action.hover,
					},
				},
				textInherit: {
					'&:hover': {
						backgroundColor: theme.palette.action.hover,
					},
				},
			},
		},
	};
}
